import { Button } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { useReviewSaveButtonContext } from './ReviewSaveButtonContext'
import styled from 'styled-components'
import { REVIEW_STEP_UUID } from 'modules/interaction/redux'

const Wrapper = styled.div`
  padding: 16px;
  background: white;

  > div {
    max-width: 608px;
    margin: auto;
  }
`

export type ReviewSaveButtonProps = {
  currentStepUuid?: string
  handleSaveAndFinish: () => void
  submitButton?: string
}

export default function ReviewSaveButton({
  currentStepUuid,
  handleSaveAndFinish,
  submitButton
}: ReviewSaveButtonProps) {
  const { t } = useTranslation()
  const { stickySaveVisible } = useReviewSaveButtonContext()

  if (!stickySaveVisible || currentStepUuid !== REVIEW_STEP_UUID) {
    return null
  }

  return (
    <Wrapper>
      <div>
        <Button onClick={handleSaveAndFinish} impactClass='situationChange'>
          {submitButton || t('step.review.submit_button')}
        </Button>
      </div>
    </Wrapper>
  )
}
